import { TransactionTypes } from "@/stores";
import { BaseAlert } from "./BaseAlert";

interface SecureQuoteErrorAlertProps {
  company: string;
  transactionType: TransactionTypes;
  onRetry?: () => void;
  error?: {
    message?: string;
    status?: number;
    code?: string;
    timestamp?: Date;
  };
}

export const SecureQuoteErrorAlert = ({
  company,
  transactionType,
  error,
}: SecureQuoteErrorAlertProps) => {
  const getErrorTitle = () => {
    if (error?.code === "TIMEOUT") return "Request Timeout";
    if (error?.code === "NETWORK_ERROR") return "Network Error";
    if (error?.status === 500) return "Server Error";
    if (error?.status === 429) return "Too Many Requests";
    return "Quote Processing Failed";
  };

  const getErrorMessage = () => {
    if (error?.message) {
      return error.message;
    }

    const baseMessage = `We encountered an issue while securing your ${
      transactionType === TransactionTypes.BUY ? "buy" : "sell"
    } quote for ${company}.`;

    if (error?.code === "TIMEOUT") {
      return `${baseMessage} The request took too long to process. Please try again.`;
    }
    if (error?.code === "NETWORK_ERROR") {
      return `${baseMessage} Please check your internet connection and try again.`;
    }
    if (error?.status === 500) {
      return `${baseMessage} Our servers are experiencing issues. Please try again in a few moments.`;
    }
    if (error?.status === 429) {
      return `${baseMessage} Too many requests. Please wait a moment before trying again.`;
    }

    return `${baseMessage} This could be due to a temporary network issue or server timeout.`;
  };

  return (
    <BaseAlert type="error" title={getErrorTitle()}>
      {error?.status && (
        <div className="flex justify-between">
          <span>Status:</span>
          <span className="font-mono">{error.status}</span>
        </div>
      )}
      <p className="text-[20px]">{getErrorMessage()}</p>
    </BaseAlert>
  );
};
